<template>
  <nav v-if="!loadingData">
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <v-row class="content-block align-end">
      <v-col :cols="mobile() ? 12 : 6" class="content-block" :class="!mobile() ? '' : 'text-center pb-6'">
        <v-chip color="anchor20opacity" text-color="accent" class="px-4" data-testid="submissions-chip">
          {{ numbSubmissions }} {{ $tc('submissions', numbSubmissions) }}
        </v-chip>
      </v-col>
      <v-col :cols="mobile() ? 12 : 6"  class="content-block" :class="!mobile() ? 'text-right' : 'text-center pb-6 pt-0'">
        <v-btn ref="download" data-testid="download-pdf-button" color="accent" min-width="100"
          class="rounded-xxl text-none px-4" @click="downloadSurveyPDF()" :loading="downloadingPDF">
          {{ $t("downloadSurveyOverviewPDF") }} <v-icon class="pl-1"> mdi-download </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <section>
      <div v-for="(question, index) in mergedArray" :key="index" class="list-group-item mb-4">
        <div class="content-block question pa-12 rounded-xxl"
          :style="`background-color:` + question.bg_color">
          <div>
            <v-row v-if="question.type == 1" align="center" justify="center" data-testid="survey-1" no-gutters>
              <v-col cols="12" sm="12" md="12">
                <MultipleChoiceTextQuestionTextAnswer :question="question" :surveyOverview="summaryOverview"
                  :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 2" align="center" justify="center" data-testid="survey-2" no-gutters>
              <v-col cols="12">
                <MultipleChoiceTextQuestionTextImageAnswer :question="question" :index="index"
                  :surveyOverview="summaryOverview" :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 3" align="center" justify="center" data-testid="survey-3" no-gutters>
              <v-col cols="12">
                <MultipleChoiceTextImageQuestionTextAnswer :question="question" :index="index"
                  :surveyOverview="summaryOverview" :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 4" align="center" justify="center" data-testid="survey-4" no-gutters>
              <v-col cols="12">
                <OpenText :question="question" :surveyOverview="summaryOverview" :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 5" align="center" justify="center" data-testid="survey-5" no-gutters>
              <v-col cols="12">
                <OpenTextAttachment :question="question" :surveyOverview="summaryOverview"
                  :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 6" align="center" justify="center" data-testid="survey-6" no-gutters>
              <v-col cols="12">
                <RatingStars :question="question" :surveyOverview="summaryOverview"
                  :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 7" align="center" justify="center" data-testid="survey-7" no-gutters>
              <v-col cols="12">
                <RatingNumbers :question="question" :surveyOverview="summaryOverview"
                  :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
            <v-row v-else-if="question.type == 8" align="center" justify="center" data-testid="survey-8" no-gutters>
              <v-col cols="12">
                <RatingNumbersComment :question="question" :surveyOverview="summaryOverview"
                  :numbSubmissions="numbSubmissions" />
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </section>
    <section id="survey-pdf-content" class="only-for-printing" style="position: fixed; top: -999999999999px;">
      <v-app style="background-color: transparent;">
        <div v-for="(question, index) in mergedArray" :key="index" class="list-group-item">
          <div class="content-block question pa-12 rounded-xxl replace-box-shadow"
            :style="`background-color:` + question.bg_color">
            <div>
              <v-row v-if="question.type == 1" align="center" justify="center" data-testid="survey-1" no-gutters>
                <v-col cols="12" sm="12" md="12">
                  <MultipleChoiceTextQuestionTextAnswer :question="question" :surveyOverview="summaryOverview"
                    :numbSubmissions="numbSubmissions" :pdf="true" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 2" align="center" justify="center" data-testid="survey-2" no-gutters>
                <v-col cols="12">
                  <MultipleChoiceTextQuestionTextImageAnswer :question="question" :index="index"
                    :surveyOverview="summaryOverview" :numbSubmissions="numbSubmissions" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 3" align="center" justify="center" data-testid="survey-3" no-gutters>
                <v-col cols="12">
                  <MultipleChoiceTextImageQuestionTextAnswer :question="question" :index="index"
                    :surveyOverview="summaryOverview" :numbSubmissions="numbSubmissions" :pdf="true" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 4" align="center" justify="center" data-testid="survey-4" no-gutters>
                <v-col cols="12">
                  <OpenText :question="question" :surveyOverview="summaryOverview" :numbSubmissions="numbSubmissions"
                    :pdf="true" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 5" align="center" justify="center" data-testid="survey-5" no-gutters>
                <v-col cols="12">
                  <OpenTextAttachment :question="question" :surveyOverview="summaryOverview"
                    :numbSubmissions="numbSubmissions" :pdf="true" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 6" align="center" justify="center" data-testid="survey-6" no-gutters>
                <v-col cols="12">
                  <RatingStars :question="question" :surveyOverview="summaryOverview"
                    :numbSubmissions="numbSubmissions" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 7" align="center" justify="center" data-testid="survey-7" no-gutters>
                <v-col cols="12">
                  <RatingNumbers :question="question" :surveyOverview="summaryOverview"
                    :numbSubmissions="numbSubmissions" />
                </v-col>
              </v-row>
              <v-row v-else-if="question.type == 8" align="center" justify="center" data-testid="survey-8" no-gutters>
                <v-col cols="12">
                  <RatingNumbersComment :question="question" :surveyOverview="summaryOverview"
                    :numbSubmissions="numbSubmissions" :pdf="true" />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-app>
    </section>
  </nav>
  <nav v-else class="fill-height d-flex align-center justify-center" style="position: fixed; top: 0; width: 100%;">
      <v-progress-circular
        size="125"
        indeterminate
        class=""
        color="grey"
      />
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import AlertMessages from "../../components/AlertMessages";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import {
  getSurveyQuestions,
  getImageURLsInActivitySurvey,
  getOverviewSurveySelection,
} from "../../api/activityApi";
import MultipleChoiceTextQuestionTextAnswer from "../../components/editor_components/survey/MultipleChoiceTextQuestionTextAnswer";
import MultipleChoiceTextQuestionTextImageAnswer from "../../components/editor_components/survey/MultipleChoiceTextQuestionTextImageAnswer";
import MultipleChoiceTextImageQuestionTextAnswer from "../../components/editor_components/survey/MultipleChoiceTextImageQuestionTextAnswer";
import RatingNumbersComment from "../../components/editor_components/survey/RatingNumbersComment";
import OpenText from "../../components/editor_components/survey/OpenText";
import OpenTextAttachment from "../../components/editor_components/survey/OpenTextAttachment";
import RatingNumbers from "../../components/editor_components/survey/RatingNumbers";
import RatingStars from "../../components/editor_components/survey/RatingStars";
import html2pdf from "html2pdf.js"

export default {
  components: {
    AlertMessages,
    MultipleChoiceTextQuestionTextAnswer,
    MultipleChoiceTextQuestionTextImageAnswer,
    MultipleChoiceTextImageQuestionTextAnswer,
    RatingNumbersComment,
    OpenText,
    OpenTextAttachment,
    RatingNumbers,
    RatingStars
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      surveyId: this.$route.params.surveyId,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      loadingData: false,
      surveys: [],
      numbSubmissions: 0,
      summaryOverview: false,
      summarySubmissions: [],
      allQuestions: [],
      mergedArray: [],
      downloadingPDF: false
    };
  },
  async created() {
    this.loadingData = true;
    await this.getOverviewSurveySelection();
    await this.getSurveyQuestions();
    this.mergeData();
    this.loadingData = false;
  },
  methods: {
    async getOverviewSurveySelection() {
      try {
        const response = await getOverviewSurveySelection(this.surveyId);
        if (response.status == 200) {
          this.summaryOverview = true;
          this.summarySubmissions = response.data.meta;
          this.numbSubmissions = response.data.meta.submissions;
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async getSurveyQuestions() {
      try {
        const response = await getSurveyQuestions(this.surveyId);
        if (response) {
          if (response.status == 200) {
            for (const value of response.data.data) {
              if (
                value.attributes.type == 1 ||
                value.attributes.type == 2 ||
                value.attributes.type == 3
              ) {
                var responseQuestionImageURL = await this.changeImageURLs(
                  value.attributes.image
                );
                var options = [];
                for (const answer of value.attributes.options) {
                  var responseAnswerImageURL = await this.changeImageURLs(
                    answer.image
                  );
                  options.push({
                    aid: answer.aid,
                    option: answer.option,
                    image: answer.image,
                    imageDisplay: responseAnswerImageURL,
                  });
                }

                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: value.attributes.image,
                  imageDisplay: responseQuestionImageURL,
                  bg_color: value.attributes.bg_color,
                  allowed_options: value.attributes.allowed_options,
                  type: value.attributes.type,
                  options: options,
                });
              } else if (
                value.attributes.type == 4 ||
                value.attributes.type == 5
              ) {
                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: null,
                  imageDisplay: null,
                  bg_color: value.attributes.bg_color,
                  type: value.attributes.type,
                });
              } else {
                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: null,
                  imageDisplay: null,
                  bg_color: value.attributes.bg_color,
                  allowed_options: value.attributes.allowed_options,
                  type: value.attributes.type,
                });
              }
            }
            //created new array that will contains all question, start screen and endscreen. For carousel scroll effect
            this.allQuestions = JSON.parse(JSON.stringify(this.surveys));
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async changeImageURLs(value) {
      var imagesToCheck = [];
      if (value != null) {
        imagesToCheck = [value];

        let dataImage = {
          data: {
            type: "surveys",
            id: this.surveyId,
            attributes: {
              paths: imagesToCheck,
              space_id: this.spaceId,
            },
          },
        };

        const responseImageQuestion = await getImageURLsInActivitySurvey(
          this.surveyId,
          dataImage
        );
        return responseImageQuestion.data.meta.files[value];
      } else {
        return null;
      }
    },
    mergeData() {
      const mergedArray = JSON.parse(JSON.stringify(this.allQuestions));

      // Merge the statistics from array2 into the corresponding objects in the mergedArray
      Object.keys(this.summarySubmissions.stats).forEach((qid) => {
        const matchingItem = mergedArray.find((item) => item.qid === qid);
        if (matchingItem) {
          // Add the stats object to the matching item
          matchingItem.stats = this.summarySubmissions.stats[qid];
        }
      });

      this.mergedArray = mergedArray;
    },
    async downloadSurveyPDF() {

      this.downloadingPDF = true;
      let element = document.getElementById('survey-pdf-content').firstChild;

      const styleElements = (selector, style, action) => {
        element.querySelectorAll(selector).forEach((item) => {
          item.style[action] = style;
        });
      };

      styleElements('.go-to-answers-row', 'hidden', 'visibility');
      styleElements('.replace-box-shadow', '1px solid #CECDCD', 'border');
      styleElements('.replace-box-shadow-input .v-input__slot', '1px solid #CECDCD', 'border');

      element.querySelectorAll('textarea').forEach((textArea) => {
        const div = document.createElement('div');
        div.innerText = textArea.value;
        div.style.padding = '4px 16px 8px 0';
        div.style.wordBreak = 'break-word';
        textArea.style.display = 'none';
        textArea.parentElement.append(div);
      });

      const createImageDiv = (img, height) => {
        const div = document.createElement('div');
        div.style.backgroundImage = `url(${img.src})`;
        div.style.backgroundSize = 'contain';
        div.style.height = `${height}px`;
        div.style.backgroundPosition = 'center';
        img.style.display = 'none';
        img.parentElement.append(div);
      };

      element.querySelectorAll('.survey-question-image-editor img').forEach((img) => {
        createImageDiv(img, 300);
      });

      element.querySelectorAll('.survey-answer-image-editor img').forEach((img) => {
        createImageDiv(img, 247);
      });
      // Add page break before every div with class list-group-item that can't fit on the same A4 page
      let pageHeight = 1122; // A4 page height in pixels, adjust as needed (A4 - 1122)
      let contentHeight = 0;

      let listGroupItems = element.querySelectorAll('.list-group-item');

      for (let i = 0; i < listGroupItems.length; i++) {
        let listItem = listGroupItems[i];
        let listItemHeight = listItem.scrollHeight + 40;
        listItem.style.padding = "20px 20px 0 20px"

        if ((contentHeight + listItemHeight) > pageHeight && i !== 0) {
          listItem.style.pageBreakBefore = "always";
          contentHeight = 0;
        }
        contentHeight += listItemHeight;
      }
      const opt = {
        margin: 0,
        filename: 'survey-overview.pdf',
        pagebreak: { mode: ['css', 'legacy', 'avoid-all'], avoid: ['img', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'a', 'span'] },
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          imageTimeout: 0
        },
        jsPDF: { unit: 'px', hotfixes: ['px_scaling'] }
      };

      await html2pdf().set(opt).from(element).save();
      this.downloadingPDF = false;
    },
  },
};
</script>
<style>
.col-sm-12 .v-list-item .survey-answer .v-text-field__slot {
  width: 0%;
}

.content-block.question {
  box-shadow: 0px 3px 1px -2px rgb(38 50 56 / 10%),
    0px 2px 2px 0px rgb(38 50 56 / 10%), 0px 1px 5px 0px rgb(38 50 56 / 10%);
}
</style>